import activities from './activities'
import addressing from './addressing'
import auth from './auth'
import company from './company'
import customer from './customer'
import dashboard from './dashboard'
import dates from './dates'
import error from './error'
import expenses from './expenses'
import finances from './finances'
import global from './global'
import invoice from './invoice'
import items from './items'
import paymentTypes from './paymentTypes'
import person from './person'
import plans from './plans'
import quotes from './quotes'
import report from './report'
import routeLeaveDialog from './routeLeaveDialog'
import salutations from './salutations'
import setting from './setting'
import statistics from './statistics'
import team from './team'
import timeTracking from './timeTracking'
import toolbar from './toolbar'

export default [
  activities,
  addressing,
  global,
  invoice,
  dashboard,
  auth,
  customer,
  person,
  company,
  setting,
  report,
  team,
  error,
  expenses,
  toolbar,
  salutations,
  items,
  statistics,
  dates,
  plans,
  routeLeaveDialog,
  paymentTypes,
  quotes,
  timeTracking,
  finances
].reduce((res, module) => {
  Object.keys(module).forEach(lang => {
    res[lang] = Object.assign(res[lang] || {}, module[lang])
  })

  return res
}, {})
